export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const isNotHaveRoutesList = [
  { id: false, name: "Yes" },
  { id: true, name: "No" },
];

export const isMaxLevelList = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

export const genderList = [
  { id: "female", name: "Female" },
  { id: "male", name: "Male" },
];

export const ccaDropOffLocationType = [
  { id: "door_to_door", name: "Door To Door" },
  { id: "fixed_location", name: "Fixed Location" },
];

export enum ScheduleTypeEnum {
  Regular = "regular",
  Cca = "cca",
  Both = "both",
}

export const scheduleTypeList = [
  { id: ScheduleTypeEnum.Regular, name: "Regular" },
  { id: ScheduleTypeEnum.Cca, name: "CCA" },
  { id: ScheduleTypeEnum.Both, name: "Both" },
];

export enum IncludeParentOptionEnum {
  ParentOnly = "parentOnly",
  ParentWithGuardian = "parentWithGuardian",
}

export const includeParentOptionList = [
  { id: IncludeParentOptionEnum.ParentOnly, name: "Parent Only" },
  { id: IncludeParentOptionEnum.ParentWithGuardian, name: "Parent With Guardian" },
];

export enum IncludeSubsidySettingOptionEnum {
  ActiveSubsidyOnly = "activeSubsidyOnly",
  AllSubsidySetting = "allSubsidySetting",
}

export const includeSubsidySettingOptionList = [
  { id: IncludeSubsidySettingOptionEnum.ActiveSubsidyOnly, name: "With Active Subsidy Setting" },
  { id: IncludeSubsidySettingOptionEnum.AllSubsidySetting, name: "With All Subsidy Setting" },
]

export enum IncludeSubsidyOptionEnum {
  SubsidySetting = "subsidySetting",
  SubsidyData = "subsidyData",
}

export const includeSubsidyOptionList = [
  { id: IncludeSubsidyOptionEnum.SubsidySetting, name: "Subsidy Setting" },
  { id: IncludeSubsidyOptionEnum.SubsidyData, name: "Subsidy Data" },
]

export enum StudentExportTypeEnum {
  Student = "students",
  StudentMasterList = "studentMasterList",
}

export const studentExportTypeList = [
  {
    id: StudentExportTypeEnum.Student,
    name: "Student Data",
  },
  {
    id: StudentExportTypeEnum.StudentMasterList,
    name: "Student Master List",
  },
];
